import React from 'react'
import Layout from '../../components/system/layout'
import Meta from '../../components/system/meta'
import { withApollo } from '../../apollo/apollo'
import gql from 'graphql-tag'
import EventHero from '../../components/event/event-hero'
import EventDetails from '../../components/event/event-details'
import { EventFragment } from '../../components/events/event-fragment'
import PACEvent from '../../models/event/pac-event'
import { ApolloClient } from 'apollo-client'
import { InMemoryCache } from 'apollo-cache-inmemory'
import Error from '../_error'

const EVENT = gql`
  query Event($slug: String!) {
    event(slug: $slug) {
      ...PACEvent
      boxOfficeUrl
      hasPassed
      performances {
        label
        startTime {
          iso
          format(format: "dddd, MMM. D: h:mma", midnightFormat: "dddd, MMM. D")
          seoFormat: format(format: "YYYY-MM-DDTHH:mm:ssZ", midnightFormat: "YYYY-MM-DD")
        }
      }
      faqs {
        question
        answer
      }
    }
  }
  ${EventFragment}
`

const Event = ({ data, loading, error }: { data: any; loading: boolean; error: any }) => {
  if (!data || !data.event) {
    return <Error title="Event Not Found" message="Hmm... That event couldn't be found." />
  }

  const event = data.event
  const pacEvent = new PACEvent(event)

  return (
    <Layout>
      <Meta title={pacEvent.name}>
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(pacEvent.getJSONSchema()) }}
        ></script>
      </Meta>
      <article>
        <EventHero event={pacEvent} />
        <EventDetails event={pacEvent} />
      </article>
    </Layout>
  )
}

Event.getInitialProps = async ({
  res,
  apolloClient,
  query
}: {
  req: any
  res: any
  apolloClient: ApolloClient<InMemoryCache>
  query: any
}) => {
  const { slug } = query

  const { data, loading, errors } = await apolloClient.query({
    query: EVENT,
    variables: {
      slug
    }
  })

  const event = data && data.event

  if (!event && res) {
    res.statusCode = 404
  }

  return { data, loading, errors }
}

export default withApollo(Event)
